<!-- 费用详情 -->
<template>
  <el-drawer
    :append-to-body="true"
    :title="$t('receivablePayable.FeeDetails')"
    :visible.sync="isVisible"
    custom-class="drawerClass"
    direction="ltr"
    size="80%"
  >
    <div class="details">
      <!-- 基本信息 -->
      <BasicForm :add-batch-fee="addBatchFee" :payable-type="payableType" />

      <!-- 费用明细 -->
      <FeeTable
        ref="detailsTableRef"
        :key="refreshKey"
        :add-type="2"
        :fee-type-option="feeTypeOption"
        :query-form="queryForm"
        :is-allow-edit="addBatchFee.allowEdit"
        :list="addBatchFeeList"
        :payable-type="payableType"
      />

      <!-- 附件管理-->
      <ImportFile
        v-if="payableType === 5"
        ref="importFileRef"
        :file-list="fileList"
      />

      <!-- 按钮 -->
      <div class="btn">
        <!--保存 allowEdit true可编辑 false查看-->
        <el-button
          v-if="addBatchFee.allowEdit"
          v-permit:remove="permission" type="primary" size="small"
          @click="submit"
        >{{ $t('basicData.Save') }}</el-button>
        <!--关闭-->
        <el-button size="small" @click="onClose">{{ $t('orderCenterCont.ShutDown') }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>

import {
  apiPayableSiteExpenseAddFee,
  apiPayableSiteExpenseGetInfo,
  apiPayableTransportExpenseAddFee,
  apiPayableTransportExpenseGetInfo
} from '@/api/finance/receivables';
import { getPermission } from './utils.js';
import { FEE_SOURCE } from '@/views/finance/payableManage/feesPayable/enums.js';
import BasicForm from './basicForm.vue';
import FeeTable from './feeTable.vue';

export default {
  components: {
    BasicForm,
    FeeTable,
    ImportFile: () => import('./importFile.vue')
  },

  props: {
    queryFeeParam: {
      type: Object,
      default: () => {
        return {};
      }
    },

    // 费用类型
    feeTypeOption: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 外部搜索条件
    queryForm: {
      type: Object,
      default: () => {
        return {};
      }
    },

    // 勾选
    selectData: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 账单类型
    payableType: {
      type: Number,
      required: true
    }

    // 是否打开了添加弹窗
    // isOpen: {
    //   type: Boolean,
    //   default: false
    // }
  },

  data() {
    return {
      isVisible: false,
      key: 1,

      addBatchFee: {
        allowEdit: true
      }, // 费用详情基本信息
      addBatchFeeList: [], // 费用详情
      permission: '', // 权限
      refreshKey: new Date().getTime(),
      fileList: [] // 附件列表
    };
  },

  activated() {
    this.permission = getPermission(this.payableType);
  },
  created() {
    this.permission = getPermission(this.payableType);
  },

  methods: {
    // 父元素调用
    open() {
      this.isVisible = true;
      this.addBatchFeeList = [];
      setTimeout(() => {
        this.getDetails();
      }, 300);
      this.refreshKey = new Date().getTime();
    },

    // 费用详情
    getDetails() {
      const params = this.payableType !== 5
        ? {
          waybillNumber: this.queryFeeParam.waybillNumber,
          businessType: this.queryFeeParam.businessType,
          payableType: this.payableType,
          siteId: this.queryFeeParam.siteId
        }
        : this.queryFeeParam.transportNumber;
      const api = this.payableType === 5 ? apiPayableTransportExpenseGetInfo : apiPayableSiteExpenseGetInfo;
      api(params).then(res => {
        console.log(res, '费用详情');
        const { code, data } = res;
        if (code === 200) {
          data['inputTime'] = data['inputTime'] ? data['inputTime'].replace('T', ' ') : '';
          data.expenseSubList.map(item => {
            if (item.inputTime) {
              item.inputTime = item.inputTime.replace('T', ' ');
            }
            if (item.operateTime) {
              item.operateTime = item.operateTime.replace('T', ' ');
            }
            item.chargeWeight = res.data.chargeWeight;
            item.isEdit = false;
          });

          const arr = (data || []).expenseSubList.map(item => {
            const feeSourceStr = FEE_SOURCE[item.feeSource]?.name || '';
            return {
              ...item,
              feeSourceStr
            };
          });

          this.$set(this, 'addBatchFee', data);
          this.addBatchFeeList = arr;
          this.fileList = JSON.parse(data.file);
        }
      });
    },

    // 批量添加费用
    async submit() {
      // 校验费用明细及获取新增费用数据
      const result = await this.$refs.detailsTableRef.submitEdit();
      console.log(result, '添加费用');
      try {
        // 获取附件数据
        let fileList = [];
        if (this.payableType === 5) {
          fileList = this.$refs.importFileRef.getFiles();
        }

        // 数据校验未通过
        if (!result) {
          return;
        }
        // 提示添加数据后才能保存
        if (!result.length && !fileList.length) {
          return this.$message.warning(this.$t('basicData.noDataAddedCannotSave'));
        }
        const params = this.payableType === 5
          ? {
            transportNumber: this.queryFeeParam.transportNumber,
            expenseSubList: result,
            file: JSON.stringify(fileList)
          }
          : {
            waybillNumber: this.queryFeeParam.waybillNumber,
            expenseSubList: result,
            businessType: this.queryFeeParam.businessType,
            payableType: this.queryFeeParam.payableType
          };
        const fn = this.payableType === 5 ? apiPayableTransportExpenseAddFee : apiPayableSiteExpenseAddFee;
        fn(params).then(res => {
          if (res.code !== 200) return;
          this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully')); // 保存成功
          this.isVisible = false;
          this.$emit('close', true);
        }).catch(err => {
          console.error(err);
        }).finally(() => {
        // 清除历史附件
          this.$refs.importFileRef.clearFiles();
        });
      } catch (error) {
        console.error(error);
      }
    },

    onClose(isBool = false) {
      this.isVisible = false;
      this.$emit('close', isBool);
      // 清除历史附件
      this.$refs.importFileRef.clearFiles();
    }
  }
};
</script>

<style scoped lang="scss">
.details {
  padding: 0 8px;
  width: 100%;
  height: calc(100vh - 74px);
  overflow-y: scroll;
}
.btn {
  position: sticky;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #eeefee;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
}
</style>
